<template>
	<div
		class="bg-fill-tertiary fixed right-0 left-0 rounded-t-xl p-4"
		:style="{ bottom, paddingBottom }"
		:class="{ 'border-b border-black': layout.bottomNavbar }"
	>
		<slot />
	</div>
</template>
<script setup lang="ts">
import { useLayout } from '@/stores/layout'
import { computed } from 'vue'

const layout = useLayout()

const bottom = computed(() => {
	return `${layout.bottomNavbar ? 'calc(var(--padding-bottom) + 71px)' : '0'}`
})

const paddingBottom = computed(() => {
	return layout.bottomNavbar ? '1rem' : 'max(var(--padding-bottom), 1rem)'
})
</script>
